import { render, staticRenderFns } from "./cotation.vue?vue&type=template&id=08279515"
import script from "./cotation.vue?vue&type=script&lang=js"
export * from "./cotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports